export default __webpack_public_path__ + "static/media/photo4.a5dddd97.jpg";